import React from 'react';

import { add, calendarFormat, parseDate } from 'helpers/date_utils';
import { DATE_FORMAT, timeFormat } from 'helpers/formatters/date_time_formats';
import { isPresent } from 'helpers/string_helpers';

const timestampFormats = {
  sameDay: `[Today at] ${timeFormat()}`,
  nextDay: '[Tomorrow]',
  nextWeek: DATE_FORMAT,
  lastDay: '[Yesterday]',
  lastWeek: '[Last] dddd',
  sameElse: DATE_FORMAT
};

const renderLabeledValue = (label, content, completed) => {
  return (
    <>
      <span className="text-muted text-uppercase me-2">{label}:</span>
      {!completed && content}
    </>
  );
};

const dueDate = (task) => {
  if (task.completed) {
    const completedAtText = calendarFormat(task.completedAt, timestampFormats);

    return renderLabeledValue("Completed", <span>{completedAtText}</span>);
  }

  if (isPresent(task.dueDate)) {
    const dueDate = parseDate(task.dueDate);
    const dueDateText = calendarFormat(dueDate, timestampFormats);
    let display;
    if (!task.completed && dueDate < new Date()) {
      // Past due
      display = <strong className="text-danger">{dueDateText}</strong>;
    } else if (!task.completed && dueDate < add(new Date(), 2, 'days')) {
      // Almost due
      display = <strong>{dueDateText}</strong>;
    } else {
      display = <span>{dueDateText}</span>;
    }

    return renderLabeledValue("Due", display);
  }
};

export default dueDate;
